import { apiRequest } from '../utils/useAPIRequest';
import constant from '../utils/constant';
import { inventoryStore } from '../stores';
import { toJS } from 'mobx';
import BusinessController from './BusinessController';
import moment from 'moment';

// const getStockAnalysis = async () => {

// 	const { status, data, errorMessage } = await apiRequest({
// 		url: '/products/stocks/analysis',
// 		method: 'get',
// 	});

// 	console.log("data", data);

// 	if (status === constant.Success) {
// 		inventoryStore.setStockAnalysis(data);
// 		return { status: constant.Success };
// 	}
// 	return { errorMessage, status };
// };

const getStockAnalysis = async (query) => {

	// if (!query) {
	// 	const startDate = moment().startOf('year');
	// 	const endDate = moment().endOf('month');
	// 	query = `startDate=${startDate}&endDate=${endDate}&dateType=createdAt&product=product`;
	// }

	const { status, data, errorMessage } = await apiRequest({
		url: `/products/stocks/new-analysis`,
		method: 'get',
	});

	// console.log("data", data);

	if (status === constant.Success) {
		inventoryStore.setStockAnalysis(data);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const getProducts = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/products/collection/business',
		method: 'get',
	});

	if (status === constant.Success) {
		inventoryStore.setProducts(data.value);
	}
	return { errorMessage, status };
};
const getStocks = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/products/stocks/business',
		method: 'get',
	});
	if (status === constant.Success) {
		inventoryStore.setStocks(data.value);
	}
	return { errorMessage, status };
};
const checkProduct = async (productCode) => {
	const { status, data, errorMessage } = await apiRequest({
		url: `/products/${productCode}`,
		method: 'get',
	});
	if (status === constant.Success) {
		inventoryStore.setStocks(data.value);
	}
	return { errorMessage, status, data };
};


const deleteStock = async id => {
	const { status, errorMessage }  = await apiRequest({
		url: `/products/deactivate/${id}`,
		method: 'patch',
	});
	if (status === constant.Success) {
		await Promise.all([
			getStockAnalysis(),
			getProducts(),
			getStocks(),
		]);
	}
	return { errorMessage, status };
}

const deleteProduct = async id => {
	const { status, errorMessage }  = await apiRequest({
		url: `/products/deactivate/product/${id}`,
		method: 'patch',
	});
	if (status === constant.Success) {
		await Promise.all([
			getStockAnalysis(),
			getProducts(),
			getStocks(),
		]);
	}
	return { errorMessage, status };
}


const updateProduct = async (payload, id) => {
	const { status, errorMessage } = await apiRequest({
		url: `/products/update-product/${id}`,
		method: 'patch',
		payload,
		hasImageUpload: true,
	});
	if (status === constant.Success) {
		await Promise.all([
			getProducts(),
			getStocks(),
			getStockAnalysis(),
		]);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const updateConfig = async (payload) => {
	const { status, errorMessage } = await apiRequest({
		url: '/products/update-config',
		method: 'patch',
		payload
	});
	if (status === constant.Success) {
		await BusinessController.businessDetails();
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const updateStocks = async (payload, id) => {
	const { status, errorMessage } = await apiRequest({
		url: `/products/update-stock/${id}`,
		method: 'patch',
		payload,
	});
	if (status === constant.Success) {
		await Promise.all([
			getStocks(),
			getProducts(),
			getStockAnalysis(),
		]);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};


const createProduct = async (payload) => {
	const { status, errorMessage } = await apiRequest({
		url: '/products',
		method: 'post',
		payload,
		hasImageUpload: true,
	});
	if (status === constant.Success) {
		await Promise.all([
			getProducts(),
			getStockAnalysis(),
		]);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const createStock = async (payload, productId) => {
	const { status, errorMessage } = await apiRequest({
		url: `/products/add-variations/${productId}`,
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		await Promise.all([
			getStocks(),
			getProducts(),
			getStockAnalysis(),
		]);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const getRates = async (currencyCode, amount) => {
	const { status, data, errorMessage } = await apiRequest({
		url: `/products/currency/rates?currencyCode=${currencyCode}&amount=${amount}`,
		method: 'get',
	});

	if (status === constant.Success) {
		const eurAmount = data?.reduce((sum, obj) => {
			if (obj.currencyCode === "EUR") {
				return sum + obj.amount;
			}
			return sum;
		}, 0);

		const gbpAmount = data?.reduce((sum, obj) => {
			if (obj.currencyCode === "GBP") {
				return sum + obj.amount;
			}
			return sum;
		}, 0);
		
		inventoryStore.setEurPrice(eurAmount);
		inventoryStore.setGbpPrice(gbpAmount);
		return { status: constant.Success, data };
	}
	return { errorMessage, status };
};

export default {
	createProduct,
	createStock,
	deleteProduct,
	updateConfig,
	updateStocks,
	updateProduct,
	deleteStock,
	getProducts,
	getStockAnalysis,
	getStocks,
	checkProduct,
	getRates
}